module.exports = __webpack_public_path__ + "img/stock7.7ee8f487.png";